import React__default from 'react';
import { Badge } from '../../display/Badge/Badge.es.js';

function PageNavigationBadge(props) {
  return React__default.createElement(
    "span",
    { "data-zds": true },
    React__default.createElement(Badge, Object.assign({}, props))
  );
}

export { PageNavigationBadge as default };
//# sourceMappingURL=PageNavigationBadge.es.js.map
